/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import authService from './auth/authService'

import FicheArticle from '@/views/adminportail/articles/FicheArticle.vue'

//import store from './store/store.js'
//import acl from './acl/acl.js'
Vue.use(Router)

const router = new Router({
    mode: 'history',
    //base: 'portail',
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [


        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================

            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '',
                    redirect: 'actualites'
                },
                {
                    path: '/actualites',
                    name: 'actualites',
                    component: () => import('@/views/Actualites.vue'),
                    meta: {
                        pageTitle: '',
                        authRequired: true,
                        rule: 'Authenticated'
                    },

                },
                {
                    path: '/societe',
                    name: 'page-societe',
                    component: () => import('@/views/users/Societe.vue'),
                    meta: {

                        rule: 'Simple',
                        authRequired: true,

                    },
                },
                {
                    path: '/profile',
                    name: 'page-profile',
                    component: () => import('@/views/users/Profile.vue'),
                    meta: {

                        pageTitle: 'Profil',
                        rule: 'Authenticated'
                    },
                },
                {
                    path: '/profile/Modifier',
                    name: 'profile-modifier',
                    component: () => import('@/views/users/user-edit/UserEdit.vue'),
                    meta: {
                        pageTitle: 'Profil',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/pages/user-settings',
                    name: 'page-user-settings',
                    component: () => import('@/views/pages/user-settings/UserSettings.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pages' },
                            { title: 'User Settings', active: true },
                        ],
                        pageTitle: 'Settings',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/user/user-list',
                    name: 'app-user-list',
                    component: () => import('@/views/users/UserListView.vue'),
                    meta: {
                        // breadcrumb: [
                        //    { title: 'Home', url: '/' },
                        //    { title: 'Utilisateurs' },
                        //     { title: 'Liste', active: true },
                        // ],
                        pageTitle: ' \xa0\xa0 ' + '  Liste des comptes',
                        rule: 'SuperAdmin'
                    },
                },
                {
                    path: '/user/commandes-list',
                    name: 'app-commandes-list',
                    component: () => import('@/views/users/CommandesListView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },

                        ],
                        pageTitle: 'Liste des commandes en cours',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/user/commande-mapview',
                    name: 'app-commande-mapview',
                    component: () => import('@/views/users/CommandeMapView.vue'),
                    meta: {

                        authRequired: true,
                        rule: 'Simple'
                    },
                },
                {
                    path: '/apps/user/user-view/:userId',
                    name: 'app-user-view',
                    component: () => import('@/views/apps/user/UserView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'User' },
                            { title: 'View', active: true },
                        ],
                        pageTitle: 'User View',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/Commande/Nouveau',
                    name: 'commande-nouveau',
                    component: () => import('@/views/commandes/nouveau.vue'),
                    meta: {
                        // pageTitle: 'Nouvelle Commande',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/telereclammation',
                    name: 'reclamation-telephoniste',
                    component: () => import('@/views/ReclamationTelephoniste/telereclamation.vue'),
                    meta: {
                        // pageTitle: 'Nouvelle Réclamation',
                        rule: 'TeleCogepha'
                    },
                },
                {
                    path: '/televente',
                    name: 'commande-telephoniste',
                    component: () => import('@/views/telecogepha/tele_commande.vue'),
                    meta: {
                        rule: 'TeleCogepha'
                    },
                },
                {
                    path: '/Commande/Mes-Commandes',
                    name: 'historique-mes-commandes',
                    component: () => import('@/views/commandes/mesCommandes.vue'),
                    meta: {
                        pageTitle: 'Liste des Commandes',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/Commande/Mes-Retours',
                    name: 'historique-mes-retours',
                    component: () => import('@/views/avoir/list.vue'),
                    meta: {
                        pageTitle: 'Liste des Retours',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/Commande/avoirs',
                    name: 'gestion-des-avoirs',
                    component: () => import('@/views/retours/list.vue'),
                    meta: {
                        pageTitle: 'Liste des avoirs',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/Commande/Retours/nouveau',
                    name: 'gestion-des-retours-nouveau',
                    component: () => import('@/views/retours/nouveau.vue'),
                    meta: {
                        pageTitle: 'Demande Retour',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/bl/liste',
                    name: 'bl-liste',
                    component: () => import('@/views/bl/liste.vue'),
                    meta: {
                        pageTitle: 'Liste des BL',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/facture/liste',
                    name: 'facture-liste',
                    component: () => import('@/views/facture/liste.vue'),
                    meta: {
                        pageTitle: 'Liste des Factures',
                        rule: ''
                    },
                },
                {
                    path: '/Reclammation',
                    name: 'Reclammation-liste',
                    component: () => import('@/views/reclammation/index.vue'),
                    meta: {
                        pageTitle: 'Liste des Réclammation',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/journal',
                    name: 'LOG CONNEXIONS',
                    component: () => import('@/views/adminportail/journal/allUserConnection.vue'),
                    meta: {
                        pageTitle: 'LOG CONNEXIONS',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/circulaire',
                    name: 'Circulaire-liste',
                    component: () => import('@/views/nouveautes/circulaire/index.vue'),
                    meta: {
                        pageTitle: 'Liste des Circulaires',
                        rule: 'Simple'
                    },
                },               
                {
                    path: '/arrivage',
                    name: 'Arrivage-liste',
                    component: () => import('@/views/nouveautes/arrivage/index.vue'),
                    meta: {
                        pageTitle: 'Liste des Arrivages',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/promotion',
                    name: 'Promotion-liste',
                    component: () => import('@/views/nouveautes/promotion/index.vue'),
                    meta: {
                        pageTitle: 'Liste des Promotion',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/retrait',
                    name: 'Retrait-liste',
                    component: () => import('@/views/nouveautes/retrait/index.vue'),
                    meta: {
                        pageTitle: 'Liste des Retrait',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/Catalogue/Shop',
                    name: 'catalogue-shop',
                    component: () => import('@/views/catalogue/catalogueShop.vue'),
                    meta: {
                        rule: 'Simple'
                    },
                },
                {
                    path: '/item/:item_id',
                    name: 'item-detail-view',
                    component: () => import('./views/catalogue/components/itemDetails.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Catalogue', url: '/Catalogue/Shop' },
                            { title: 'Détail Article', active: true }
                        ],
                        pageTitle: 'Détail Article',
                        rule: 'Simple'
                    }
                },
                {
                    path: '/f/mesarticles',
                    name: 'four-articles',
                    component: () => import('./views/fournisseur/mesproduits.vue'),
                    meta: {
                        rule: 'Fournisseur'
                    }
                },
                {
                    path: '/f/mesarticles/nouveau',
                    name: 'four-articles-nouveau',
                    component: () => import('./views/fournisseur/NouveauProduit.vue'),
                    meta: {
                        rule: 'Fournisseur'
                    }
                },

                {
                    path: '/f/doc/historique',
                    name: 'four-doc',
                    component: () => import('./views/fournisseur/documents/HistoriqueDoc.vue'),
                    meta: {
                        rule: 'Fournisseur'
                    }
                }, {
                    path: '/f/doc/commandes',
                    name: 'four-doc',
                    component: () => import('./views/fournisseur/documents/HistCommandes.vue'),
                    meta: {
                        rule: 'Fournisseur'
                    }
                },
                {
                    path: '/charts/chartjs',
                    name: 'charts-chartjs',
                    component: () => import('@/views/apps/charts/chartjs/Chartjs.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Charts & Maps' },
                            { title: 'chartjs', },
                        ],
                        pageTitle: 'chartjs',
                        rule: 'Authenticated'
                    },
                },
                // Admin potail routes  
                {
                    path: '/admin/clients',
                    name: 'charts-chartjs',
                    component: () => import('@/views/adminportail/gestionclient/ListeClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Client' },
                            { title: 'ListeClient', },
                        ],
                        pageTitle: 'Liste Client',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/gestionnaires',
                    name: 'new_admin',
                    component: () => import('@/views/adminportail/gestionAdminstrateur/nouveauAdmin.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Nouveau Admin' },
                            { title: 'Admin', },
                        ],
                        pageTitle: 'Admin',
                        rule: 'GestionnairePortail'
                    },
                }, {
                    path: '/admin/gestionnaires/liste',
                    name: 'list_admin',
                    component: () => import('@/views/adminportail/gestionAdminstrateur/listAdmin.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Admin' },
                            { title: 'Admin', },
                        ],
                        pageTitle: 'Admin',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/clients',
                    name: 'charts-chartjs',
                    component: () => import('@/views/adminportail/gestionclient/ListeClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Client' },
                            { title: 'ListeClient', },
                        ],
                        pageTitle: 'Liste Client',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/fournisseurs',
                    name: 'Gestion Fournisseur',
                    component: () => import('@/views/adminportail/gestionfournisseur/ListFournisseur.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Fournisseur' },
                            { title: 'ListeFournisseur', },
                        ],
                        pageTitle: 'Liste Fournisseur',
                        rule: 'GestionFournisseurPortail'
                    },
                }, {
                    path: '/admin/fournisseurs/demande/compte',
                    name: 'Gestion Fournisseur',
                    component: () => import('@/views/adminportail/gestionfournisseur/NouvelleCreationList.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'ListeFournisseur', },
                        ],
                        pageTitle: 'Liste Fournisseur',
                        rule: 'GestionFournisseurPortail'
                    },
                },
                {
                    path: '/admin/client/satisfaction/global',
                    name: 'Satisfaction client',
                    component: () => import('@/views/adminportail/satisfaction/client/global.vue'),
                    meta: {
                        pageTitle: 'Satisfaction client',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/client/satisfaction/detaillee',
                    name: 'Satisfaction client',
                    component: () => import('@/views/adminportail/satisfaction/client/detaillee.vue'),
                    meta: {
                        pageTitle: 'Liste clients',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/client/satisfaction/detaillee/:client_id',
                    name: 'item-detail-view',
                    component: () => import('./views/adminportail/satisfaction/client/ficheClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste clients', url: '/admin/client/satisfaction/detaillee' },
                            { title: 'Détail Client', active: true }
                        ],
                        pageTitle: 'Détail Client',
                        rule: 'GestionnairePortail'
                    }
                },
                {
                    path: '/admin/vente',
                    name: 'Gestion Fournisseur',
                    component: () => import('@/views/adminportail/gestionfournisseur/ListFournisseur.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Création' },
                            { title: 'ListeFournisseur', },
                        ],
                        pageTitle: 'Liste Nouvelle Création',
                        rule: 'GestionFournisseurPortail'
                    },
                },
                {
                    path: '/admin/Livreur',
                    name: 'Gestion Livreurs',
                    component: () => import('@/views/adminportail/suiviLivreur/ListLivreur.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Livreurs' },
                            { title: 'Liste Livreurs', },
                        ],
                        pageTitle: 'Liste Livreurs',
                        rule: 'GestionnairePortail'
                    },
                }, {
                    path: '/admin/Livreur/maps',
                    name: 'Gestion Livreurs',
                    component: () => import('@/views/adminportail/suiviLivreur/suivLivreur.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Livreurs' },
                            { title: 'Suivi Livreurs', },
                        ],
                        pageTitle: 'Suivi Livreurs',
                        rule: 'GestionnairePortail'
                    },
                }, 
                {
                    path: '/admin/Reclammations',
                    name: 'Gestion Reclammations',
                    component: () => import('@/views/adminportail/reclamations/list.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'Reclammations', },
                        ],
                        pageTitle: 'Reclammations',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/Circulaire',
                    name: 'Gestion Circulaires',
                    component: () => import('@/views/adminportail/circulaire/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'Circulaires', },
                        ],
                        pageTitle: 'Circulaires',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/CirculaireClient',
                    name: 'Liste des Circulaires',
                    component: () => import('@/views/CirculaireClient/circulaireClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste des Circulaires' },
                            { title: 'Liste des Circulaires', },
                        ],
                        pageTitle: 'Liste des Circulaires',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/client/journal',
                    name: 'LOG CONNEXIONS',
                    component: () => import('@/views/journalClient/allConnectionSousCompte.vue'),
                    meta: {
                        pageTitle: 'LOG CONNEXIONS',
                        rule: 'SuperAdmin'
                    },
                },
                {
                    path: '/ArrivageClient',
                    name: 'Liste des Arrivages',
                    component: () => import('@/views/ArrivageClient/arrivageClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste des Arrivages' },
                            { title: 'Liste des Arrivages', },
                        ],
                        pageTitle: 'Liste des Arrivages',
                        rule: 'Simple'
                    },
                },
                {
                    path: '/nouvelArticle',
                    name: 'Liste des nouveaux articles',
                    component: () => import('@/views/NouvelArticle/nouvelArticle.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste des nouveaux articles' },
                            { title: 'Liste des nouveaux articles', },
                        ],
                        pageTitle: 'Liste des nouveaux articles',
                        rule: 'Authenticated'
                    },
                },
                {
                    path: '/admin/arrivage',
                    name: 'Arrivage',
                    component: () => import('@/views/adminportail/arrivage/arrivageVue.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'Arrivage', },
                        ],
                        pageTitle: 'Arrivage',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/repartition',
                    name: 'Repartition',
                    component: () => import('@/views/adminportail/repartition/repartitionVue.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'Repartition', },
                        ],
                        pageTitle: 'Repartition',
                        rule: 'GestionnairePortail'
                    },
                },
                {
                    path: '/admin/manquant',
                    name: 'Repartition',
                    component: () => import('@/views/adminportail/manquant/manquantVue.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Admin' },
                            { title: 'Manquant', },
                        ],
                        pageTitle: 'Manquant',
                        rule: 'GestionnairePortail'
                    },
                },
                 {
                    path: '/admin/clients/stat',
                    name: 'Stat Clients',
                    component: () => import('@/views/adminportail/gestionclient/StatClient.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Clients' },
                            { title: 'Clients', },
                        ],
                        pageTitle: 'Analyse & Statistique',
                        rule: 'GestionnairePortail'
                    },
                }, {
                    path: '/admin/articles', 
                    name: 'Liste Articles',
                    component: () => import('@/views/adminportail/articles/listarticles'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Articles' },
                            { title: 'Articles', },
                        ],
                        pageTitle: 'Articles',
                        rule: 'Gestionnaire'
                    },
                },
                {
                    path: '/admin/articles/nouveau',
                    name: 'Nouvelle Creation List',
                    component: () => import('@/views/adminportail/articles/ListeNouvelleCreation.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Liste Articles' },
                            { title: 'Nouvelle Creation', },
                        ],
                        pageTitle: 'Nouvelle Creation',
                        rule: 'Gestionnaire'
                    },
                },
                {
                    path: '/admin/notification/nouveau',
                    name: 'Nouvelle notification',
                    component: () => import('@/views/adminportail/notification/nouveau.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Notification', url: '/' },
                            { title: 'Nouvelle notification' },
                            { title: 'Nouvelle notification', },
                        ],
                        pageTitle: 'Notifications',
                        rule: 'Gestionnaire'
                    },
                },
                {
                    path: '/admin/notification/historique',
                    name: 'Historique',
                    component: () => import('@/views/adminportail/notification/historique.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Historique', url: '/' },
                            { title: 'Historique' },
                            { title: 'Historique', },
                        ],
                        pageTitle: 'Historique',
                        rule: 'Gestionnaire'
                    },
                },
                {
                    path: '/admin/notification/backoffice',
                    name: 'Backoffice',
                    component: () => import('@/views/adminportail/notification/backoffice.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Backoffice', url: '/' },
                            { title: 'Backoffice' },
                            { title: 'Backoffice', },
                        ],
                        pageTitle: 'Backoffice',
                        rule: 'Gestionnaire'
                    },
                },
                {
                    path: '/AllNotifications',
                    name: 'All notification',
                    component: () => import('@/views/AllNotifications/allNotification.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Notifications', url: '/' },
                            { title: 'Notifications' },
                            { title: 'Notifications', },
                        ],
                        pageTitle: 'Notifications',
                        rule: 'SuperAdmin' 
                    },
                },
                 {
                    path: '/admin/articles/:article_id',
                    name: 'detailsArticles',
                    component: FicheArticle,
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Fiche Article' },
                            { title: 'Fiche Article' },
                        ],
                        pageTitle: 'Articles',
                        rule: 'Gestionnaire'
                    },
                },


            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================

                {
                    path: '/home',
                    name: 'page-home',
                    component: () => import('@/views/home.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                }, {
                    path: '/f/demande/nouveau',
                    name: 'four-compte-nouveau',
                    component: () => import('./views/fournisseur/creationFournisseur/nouveau.vue'),
                    meta: {
                        rule: 'Public'
                    }
                },

                {
                    path: '/callback',
                    name: 'auth-callback',
                    component: () => import('@/views/Callback.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/login',
                    name: 'page-login',
                    component: () => import('@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'Public'
                    },

                },
                {
                    path: '/f/login',
                    name: 'page-login-four',
                    component: () => import('@/views/pages/login/LoginFournisseur.vue'),
                    meta: {
                        rule: 'Public'
                    },

                },
                {
                    path: '/f/register',
                    name: 'page-register',
                    component: () => import('@/views/pages/register/Register.vue'),
                    meta: {
                        rule: 'Public'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () => import('@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () => import('@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/lock-screen',
                    name: 'page-lock-screen',
                    component: () => import('@/views/pages/LockScreen.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/comingsoon',
                    name: 'page-coming-soon',
                    component: () => import('@/views/pages/ComingSoon.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () => import('@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'Authenticated'
                    }
                },
                {
                    path: '/pages/not-authorized',
                    name: 'page-not-authorized',
                    component: () => import('@/views/pages/NotAuthorized.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
                {
                    path: '/pages/maintenance',
                    name: 'page-maintenance',
                    component: () => import('@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'Simple'
                    }
                },
            ]
        },
        // Redirect to 404 page, if no match found

    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
    authService.setrole();

    // get firebase current user

    // if (
    //     to.path === "/pages/login" ||
    //     to.path === "/pages/forgot-password" ||
    //     to.path === "/pages/error-404" ||
    //     to.path === "/pages/error-500" ||
    //     to.path === "/pages/register" ||
    //     to.path === "/callback" ||
    //     to.path === "/pages/comingsoon" ||
    //     (auth.isAuthenticated() || firebaseCurrentUser)
    // ) {
    //     return next();
    // }


    if (to.path === "/login") {
        if (authService.isAuthenticated()) {
            router.push('/actualites')
        }
    } 

    // If auth required, check login. If login fails redirect to login page
    if (to.meta.authRequired) {


        if (!authService.isAuthenticated())
            router.push('/login')
        next();
    }

    return next()
    // Specify the current path as the customState parameter, meaning it
    // will be returned to the application after auth
    // auth.login({ target: to.path });



});



export default router
